import React from 'react';

export const ProtectedRouteContext = React.createContext();

export const UserStateContext = React.createContext({
    doingAjax: null,
});

export const FormContext = React.createContext({
    triggerValidation: null,
    validationFinished: null,
});

export const ShipyardContext = React.createContext({
    user: null,
    userSettings: null,
    listSettings: {
        target: null,
        reducerState: null,
        useCache: false,
    },
});
